import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import InvertAdvertisingAgreementDocument from '../../../components/InvertAdvertisingAgreementDocument/InvertAdvertisingAgreementDocument';
import './AdvertiserAdvertisingAgreement.css';

export default function AdvertiserAdvertisingAgreement({ embedded = false }) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const amountParam = searchParams.get('amountUsd') || searchParams.get('amount');
    const amountUsd = amountParam != null && amountParam !== '' ? Number(amountParam) : undefined;
    const screenCountParam = searchParams.get('screenCount') || searchParams.get('screens');
    const screenCount =
        screenCountParam != null && screenCountParam !== ''
            ? Math.max(0, Math.floor(Number(screenCountParam)))
            : 0;
    const selectedScreenIds = (searchParams.get('screenIds') || '')
        .split(',')
        .map((id) => parseInt(id.trim(), 10))
        .filter((id) => Number.isFinite(id) && id > 0);

    const content = (
        <InvertAdvertisingAgreementDocument
            amountUsd={Number.isFinite(amountUsd) ? amountUsd : undefined}
            screenCount={screenCount || selectedScreenIds.length}
            selectedScreenIds={selectedScreenIds}
            showEsignNotice
            showSignatures
        />
    );

    if (embedded) {
        return <div className="advertiser-ad-agreement-embedded">{content}</div>;
    }

    return (
        <div className="advertiser-ad-agreement-page">
            <nav className="advertiser-ad-agreement-nav">
                <button type="button" className="advertiser-ad-agreement-brand" onClick={() => navigate('/')}>
                    INVERT
                </button>
            </nav>
            <main className="advertiser-ad-agreement-main">
                <div className="advertiser-ad-agreement-card">
                    <p className="advertiser-ad-agreement-intro">
                        {screenCount > 0 || selectedScreenIds.length > 0
                            ? `Screen-targeted advertising on your selected INVERT screen(s). Each selected screen includes a guaranteed minimum of 5,400 ad plays per billing period (180 plays per screen per day × 30 days).`
                            : 'Advertising on participating INVERT screens. Each screen in your package includes a guaranteed minimum of 5,400 ad plays per billing period (180 plays per screen per day × 30 days).'}
                    </p>
                    {content}
                </div>
            </main>
        </div>
    );
}
